import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useFieldArrayOf } from '@framework/form/form/relations/useFieldsArrayOf.ts';
import { SelectInput } from '@framework/form/inputs/SelectInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Button, Space } from 'antd';
import { useMemo } from 'react';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact.ts';
import { resolveChildrenReferences } from '../../../expressions/references/resolve/resolveTreeReferences.ts';
import { RuleType } from '../../IRule.ts';
import { type IRuleConfigComponentProps } from '../../IRuleType.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';
import { type IUniqueSingleFieldRule } from './UniqueFieldRule.rule.ts';

const fieldName = `rules.${RuleType.UniqueField}`;

export function UniqueFieldRuleComponent(props: IRuleConfigComponentProps) {
  const { widget } = props;

  const inputChildrenWidget = useMemo(() => {
    if (!widget) {
      return [];
    }
    return resolveChildrenReferences([], widget)
      .filter(ref => ref.path.length === 0)
      .map(ref => ({
        label: ref.code ?? ref.label ?? ref.id,
        value: ref.code,
      }))
      .sort((a, b) => {
        if (a.label && b.label) {
          return a.label.localeCompare(b.label);
        }
        return 0;
      });
  }, [widget]);

  const { fields, append, remove } = useFieldArrayOf({
    name: `${fieldName}.groups`,
  });

  return (
    <Space direction="vertical" style={{ width: '100%', margin: '20px 0 0 0' }}>
      {fields.map((field, i) => (
        <div key={field.id}>
          <FormItem
            name={`${fieldName}.groups.${i}.fieldCodes`}
            label="Codici dei campi"
            help="Indica che nelle ripetizioni la combinazione dei campi selezionati deve essere univoca."
          >
            <$SpaceCompact block size="large">
              <SelectInput
                name={`${fieldName}.groups.${i}.fieldCodes`}
                mode="multiple"
                options={inputChildrenWidget}
                showSearch
                optionFilterProp="label"
                size="large"
              />
              <CustomValidationRuleMessage
                name={`${fieldName}.groups.${i}.customMessage`}
              />
              <Button
                danger
                size="large"
                onClick={() => {
                  remove(i);
                }}
                icon={<DeleteOutlined />}
              />
            </$SpaceCompact>
          </FormItem>
        </div>
      ))}
      <Button
        size="large"
        style={{ width: '100%' }}
        onClick={() => {
          append({} as IUniqueSingleFieldRule);
        }}
      >
        <Space>
          <PlusOutlined aria-hidden="true" /> Aggiungi gruppo di campi...
        </Space>
      </Button>
    </Space>
  );
}
